import Link from 'next/link'
import {FaRegSurprise} from 'react-icons/fa';


const AccountEmpty = ()=>{
    return <div className="cartEmpty cartEmpty-user marginBottom">
        <div>
            <FaRegSurprise/>
            <h1 className="title">No haz hecho ninguna compra</h1>
            <p className="cartDescription">Para poder las opciones de tus compras, debes haber comprado alguna, despues de hacer tu compra regresa a este sección.</p>
        </div>
    </div>
};

export default AccountEmpty;